import common from './common';
import footer from './footer';
import header from './header';
import pageAbout from './page-about';
import pageDate from './page-date';
import pageIndex from './page-index';
import pageNotFound from './page-not-found';
import { sections } from './sections';
import seo from './seo';
import { utils } from './utils';

export {
  common,
  footer,
  header,
  pageIndex,
  pageAbout,
  pageDate,
  pageNotFound,
  seo,
  sections,
  utils,
};
const Lexemes = {
  common,
  footer,
  header,
  pageIndex,
  pageAbout,
  pageDate,
  pageNotFound,
  seo,
  sections,
  utils,
};

export default Lexemes;
